import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const ExportsWorkPlanner = () => {
  return <DepartmentWorkPlanner department="exports" departmentName="Exports Department" />;
};

export default ExportsWorkPlanner;
